import React, { ReactNode } from 'react';
import { StandardButton } from '../../standard';

export interface Tab {
  id: string;
  label: string;
  badge?: string | number;
  disabled?: boolean;
}

export interface TabNavigationProps {
  tabs: Tab[];
  activeTab: string;
  onTabChange: (tabId: string) => void;
  className?: string;
}

const TabNavigation: React.FC<TabNavigationProps> = ({
  tabs,
  activeTab,
  onTabChange,
  className = ''
}) => {
  return (
    <div className={`border-b border-gray-200 dark:border-gray-700 ${className}`}>
      <nav className="-mb-px flex space-x-8" aria-label="Tabs">
        {tabs.map((tab) => {
          const isActive = activeTab === tab.id;
          const isDisabled = tab.disabled;

          return (
            <StandardButton
              key={tab.id}
              variant="ghost"
              onClick={() => !isDisabled && onTabChange(tab.id)}
              disabled={isDisabled}
              className={`
                whitespace-nowrap py-4 px-1 border-b-3 font-medium text-sm
                ${
                  isActive
                    ? 'border-purple-600 dark:border-purple-400 text-purple-600 dark:text-purple-400'
                    : isDisabled
                    ? 'border-transparent text-gray-400 dark:text-gray-600 cursor-not-allowed'
                    : 'border-transparent text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300 hover:border-gray-300 dark:hover:border-gray-600'
                }
              `}
            >
              {tab.label}
              {tab.badge !== undefined && (
                <span
                  className={`ml-2 inline-flex items-center justify-center px-2 py-0.5 text-xs font-semibold rounded-full ${
                    isActive
                      ? 'bg-purple-100 dark:bg-purple-900 text-purple-800 dark:text-purple-200'
                      : 'bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-400'
                  }`}
                >
                  {tab.badge}
                </span>
              )}
            </StandardButton>
          );
        })}
      </nav>
    </div>
  );
};

export default TabNavigation;
